import { Component, OnDestroy, OnInit } from '@angular/core';

import { TitleService } from '~/core/services/title/title.service';
import { MessagingUserInterface } from '~/messaging/interfaces/user.interface';
import { MessagingService } from '~/messaging/services/messaging.service';
import { TalkService } from '~/messaging/services/talk.service';

@Component({
  selector: 'app-organizer-messaging-inbox',
  templateUrl: './inbox.component.html',
})
export class OrganizerMessagePageInboxComponent implements OnInit, OnDestroy {
  public recipient: MessagingUserInterface;

  constructor(
    private readonly messagingService: MessagingService,
    private readonly titleService: TitleService,
    public readonly talkService: TalkService
  ) {}

  public ngOnDestroy(): void {
    this.messagingService.removeRecipient();
    this.messagingService.removeActivityData();
  }

  public ngOnInit(): void {
    this.titleService.setPageTitle('seo.organizer.messaging.inbox.title');

    this.recipient = this.messagingService.getRecipient();
  }
}
